import { render } from "./OnDemandBookingTelehealthWaitingRoomOverlay.vue?vue&type=template&id=4f181e0c&scoped=true&ts=true"
import script from "./OnDemandBookingTelehealthWaitingRoomOverlay.vue?vue&type=script&lang=ts"
export * from "./OnDemandBookingTelehealthWaitingRoomOverlay.vue?vue&type=script&lang=ts"

import "./OnDemandBookingTelehealthWaitingRoomOverlay.vue?vue&type=style&index=0&id=4f181e0c&lang=scss&scoped=true"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f181e0c"]])

export default __exports__